import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRestService } from "./base-rest.service";
import {LoanNotes} from "@app/models/loan-notes";

@Injectable({
    providedIn: 'root'
})
export class LoansNotesService extends BaseRestService {

    readonly LOAN_NOTE_URL: string = environment.loanUri + '/loan-notes';

    getList(pageParams: any): Observable<any> {
        const options = {
            headers: this.headers,
            params: this.removeEmptyPropertyFromObject(pageParams)
        }
        return this.httpClient.get(this.LOAN_NOTE_URL, options);
    }

    getLoanById(id): Observable<any> {
        const options = {
            headers: this.headers
        }
        return this.httpClient.get(this.LOAN_NOTE_URL + '/' + id, options);
    }

    create(data: LoanNotes): Observable<any> {
        return this.httpClient.post(this.LOAN_NOTE_URL, JSON.stringify(data),
            { headers: this.headers });
    }

    update(accountType: LoanNotes): Observable<any> {
        return this.httpClient.put(this.LOAN_NOTE_URL + '/' + accountType.id, JSON.stringify(accountType),
            { headers: this.headers });
    }

    delete(id: string): Observable<any> {
        return this.httpClient.delete(this.LOAN_NOTE_URL + "/" + id,
            { headers: this.headers });
    }

    findLoanNoteParents(loanNote: LoanNotes, loanNotes: Array<LoanNotes>) {
        let items = [];
        if (loanNote) {
          items.push(loanNote);
          if (loanNotes && loanNotes.length > 0) {
            var parentItem = this.findLoanNoteById(loanNote.parentLoanNoteId, loanNotes);
            if (parentItem) {
              items = items.concat(this.findLoanNoteParents(parentItem, loanNotes));
            }
          }
        }
        return items;
    }

    findLoanNoteById(id: string, items: Array<LoanNotes>) {
        if (id) {
          if (items && items.length > 0) {
            var item = items.find((p) => p.id == id);
            if (item) {
              return item;
            }

            for (var i = 0; i < items.length; i++) {
              var item = this.findLoanNoteById(id, items[i].subLoanNotes);
              if (item) {
                return item;
              }
            }
          }
        }
        return undefined;
    }
}